import { TileRoleRoute } from '@/types'
import { faGroupArrowsRotate } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'

export const PiattaformaAttivitaLavorativaRoute: TileRoleRoute = {
  path: 'piattaformaattivitalavorativa',
  text: 'Piattaforma Attivita Lavorativa',
  faIcon: faGroupArrowsRotate,
  element: (
    <ManagementGridFactory
      entity="piattaforma_attivita_lavorativa"
      referencesCollection={'attivita_lavorative'}
      referencesTitle="Piattaforma Attivita Lavorativa"
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Piattaforma Attivita Lavorativa',
      icon: faGroupArrowsRotate,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
}
